import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AETGVPACAList from './aetgv-paca-list';
import AETGVPACAForms from './aetgv-paca-forms';
import { paths } from '../../../routes';

const Asct = () => (
  <Switch>
    <Route path={paths.newAetgv.path}>
      <AETGVPACAForms />
    </Route>
    <Route path={paths.aetgv.path + '/:reportId'}>
      <AETGVPACAForms />
    </Route>
    <Route path={paths.aetgv.path}>
      <AETGVPACAList />
    </Route>
  </Switch>
);

export default Asct;
